export default {
  text: {
    type: 'string',
    required: false,
  },
  status: {
    type: 'string',
    required: true,
  },
  totalHoursSpent: {
    type: 'number',
    required: true,
  },
  deliveryDate: {
    type: 'date',
    required: {
      value: true,
      when: {
        '$.status': {
          eq: 'ENDED',
        },
      },
    },
  },
  links: {
    type: 'array',
    maxSize: 100,
    required: {
      value: true,
      when: {
        '$.status': {
          eq: 'ENDED',
        },
      },
    },
    forEach: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          required: {
            value: true,
            when: {
              '$.status': {
                eq: 'ENDED',
              },
            },
          },
        },
        url: {
          type: 'string',
          link: true,
          required: {
            value: true,
            when: {
              '$.type': {
                ne: null,
              },
            },
          },
        },
      },
    },
  },
};
